module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"1":"Séparez les compétences par une virgule, un point-virgule, ou un retour à la ligne.","2":"Compétences principales","3":"Nom de la catégorie","4":"Liste de compétences","5":"Ajouter une catégorie"},"en":{"1":"Separate skills with a comma, semicolon, or a newline.","2":"Main skills","3":"Category name","4":"Skills list","5":"Add a category"}}')
  delete Component.options._Ctor
}
